import {useSelector} from 'react-redux';
import {currentSlideIndexSelector, visibleSlideSelector} from '../../../store/selectors/presentation.selectors';

function PresentationProgressBar(): JSX.Element | null {
    const currentSlideIndex = useSelector(currentSlideIndexSelector);
    const slides = useSelector(visibleSlideSelector);
    const total = slides?.length ?? 0;

    if (total === 0) {
        return null;
    }

    const current = currentSlideIndex + 1;
    const percent = (current / total) * 100;

    return (
        <div
            className="c-presentationProgress"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(percent)}
            data-cy="presentation_progress"
        >
            <div className="c-presentationProgress__fill" style={{width: `${percent}%`}} />
        </div>
    );
}

export default PresentationProgressBar;
